/* global FormData */

import { BaseResBody } from "../../types/common.types";
import { DocumentUploadResBody } from "../../types/dashboard.types";
import NetworkService from "./base.network";

class DashboardNetworkService extends NetworkService {
  async uploadFile(formData: FormData, filename: string): Promise<BaseResBody<DocumentUploadResBody>> {
    const result = await this.apiCall<DocumentUploadResBody, FormData>({
      url: "/documents/signature-requests",
      method: "POST",
      data: formData,
      params: { is_keep_form_fields: true },
      headers: { "Content-Type": "multipart/form-data" },
    });
    if (result.type === "success") result.data.filename = filename;

    return result;
  }
}

export const dashboardNetwork = new DashboardNetworkService();

export default dashboardNetwork;
